import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Dotdotdot } from "../../../dotdotdot/src";
export const Title = ({ ariaLabel, isMobile, title, }) => (_jsx(StyledTitle, { "aria-label": ariaLabel, tabIndex: 0, width: "90%", children: _jsx(Dotdotdot, { clamp: isMobile ? 2 : 1, children: title }) }));
export const StyledTitle = styled(Box).attrs(() => ({
    fontSize: 3,
    fontWeight: 600,
    mb: 1,
    mt: 2,
})) ``;
//# sourceMappingURL=Title.js.map